import { useEffect, useRef } from "react"

const IntercomMessenger = ({ user, sessionDuration = 86400000 }) => {
  const intercomRef = useRef(null)

  useEffect(() => {
    // Only initialize Intercom if we have a user
    if (!user) {
      return
    }

    const initializeIntercom = async () => {
      // First, shutdown any existing Intercom session to prevent conflicts
      if (window.Intercom) {
        window.Intercom("shutdown")
      }
      try {
        // Fetch JWT token from our backend
        const response = await fetch("/intercom/token", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""
          },
          credentials: "same-origin"
        })

        if (!response.ok) {
          console.error("Failed to fetch Intercom JWT token")
          return
        }

        const data = await response.json()

        if (!data.success || !data.token) {
          console.error("Invalid response from Intercom token endpoint")
          return
        }

        // Initialize Intercom with JWT authentication
        window.Intercom("boot", {
          app_id: data.app_id,
          intercom_user_jwt: data.token,
          session_duration: sessionDuration,
          // You can add additional non-sensitive attributes here
          // These will be sent outside the JWT and can be updated by the user
          user_type: user.practitioner ? "practitioner" : "consumer",
          has_practice: !!user.practice,
          // Add any other non-sensitive data you want to track
          // Custom positioning (CSS will override this, but good to have as fallback)
          horizontal_padding: 20,
          vertical_padding: 20
        })

        // Store reference for cleanup
        intercomRef.current = window.Intercom
      } catch (error) {
        console.error("Error initializing Intercom:", error)
      }
    }

    initializeIntercom()

    // Cleanup function
    return () => {
      if (intercomRef.current) {
        window.Intercom("shutdown")
      }
    }
  }, [user, sessionDuration])

  // Component doesn't render anything visible
  return null
}

export default IntercomMessenger
